import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import OptSearch2 from "../../Elements/OptSearch2/OptSearch2";
import AudioPlayer from "react-custom-audio-player";
import $ from "jquery";
import PaginationList from "../PaginationList";

export default class View_type_13 extends Component {
  constructor(props) {
    super(props);
    //console.log("View_type_13: ", props);
    var data = Array.isArray(props.data) ? props.data[0] : props.data;
    this.state = {
      data: data,
      r_menu: data.right_menu ? data.right_menu : [],
      title: data.title ? data.title : "",
      tabs: data.tabs ? props.data.tabs : [],
      calendar: data.calendar ? data.calendar : null,
      content: data.content ? data.content : [],
      read_more: data.read_more ? data.read_more : [],
      list: data.list ? data.list : [],
    };

    $(document).ready(function () {
      if (window.location.href.indexOf("chopin/rekopisy") > -1) {
        $(".vt2-ChopinLists__search").remove();
      }
    });
  }

  createMarkup(item) {
    return { __html: item };
  }

  inputHandler = (e) => {
    //console.log(e.target.value);
  };

  render() {
    const { description } = this.props.data;
    var _this = this;
    var var1 = this.state.data.title ? this.state.data.title : "";

    var calendar = this.state.calendar ? (
      <Link to={this.state.calendar.url}>
        <div className="vt2-calendar">
          <img className="vt2-calendar-img" src={this.state.calendar.img} />
          {this.state.calendar.text}
        </div>
      </Link>
    ) : null;

    const paginationList = this.state.data.pagination_list ? (
      <PaginationList {...this.state.data} />
    ) : null;

    return (
      <div className="vt2">
        <div className="vt2 left col-xs-12 col-sm-12 col-md-8 col-lg-9">
          <div className="vt2 row">
            <div className="vt2-title">
              <div
                className="vt2-title-name artists-pageTitle"
                dangerouslySetInnerHTML={{ __html: var1 }}
              />
              {this.props.data.starting_page ? (
                <p className="">{description}</p>
              ) : (
                <p className="vt2_chopin_list__description">{description}</p>
              )}
              <div className="vt2-ChopinLists__search">
                <input
                  onChange={this.inputHandler}
                  type="text"
                  placeholder="wpisz: rok, nadawca, adresat, rok, miejsce..."
                />
                <span className="vt2-ChopinLists__advanced-search">
                  szukanie zaawansowane
                </span>
              </div>
              <div className="vt2-title-tabs">
                {this.state.tabs.map(function (object, i) {
                  if (object.active === 1) {
                    return (
                      <div
                        className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
                        key={i}
                      >
                        <div className="vt2 tab-checked">
                          <Link to={"/" + object.link}>{object.title}</Link>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
                        key={i}
                      >
                        <Link to={"/" + object.link}>{object.title}</Link>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
            {this.state.data.optional_search_area ? (
              <OptSearch2 {...this.state.data} />
            ) : null}
            <div className="vt2-content">
              <div
                dangerouslySetInnerHTML={_this.createMarkup(this.state.content)}
              />
            </div>
            <div className="flex-wrap">
              {this.state.data.list.map(function (object, i) {
                //console.log("tlo", object.img);
                if (object.cols == 3) {
                  var color = "rgba(0,156,178,0.5)";

                  if (
                    object !== "undefined" &&
                    object.hasOwnProperty("img") &&
                    !object.hasOwnProperty("text")
                  ) {
                    var img = object.img;
                    var thumbnail = (
                      <div
                        style={{
                          flex: 1,
                          backgroundColor: color,
                          padding: 10,
                          color: "white",
                          position: "absolute",
                          left: 15,
                          right: 15,
                        }}
                      >
                        {object.title}
                      </div>
                    );
                    return (
                      <div
                        className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        key={i}
                      >
                        <div>
                          {thumbnail}
                          <img src={img} className="vt2 list_image" />
                        </div>
                      </div>
                    );
                  } else if (object !== "undefined") {
                    var button = null;
                    var img = object.img;
                    var thumbnail = (
                      <div
                        className="vt2 middle-thumbnailholder"
                        style={{
                          flex: 1,
                          backgroundColor: color,
                          padding: 10,
                          color: "white",
                        }}
                      >
                        {object.title}
                      </div>
                    );
                    var img = (
                      <div>
                        <img src={img} />
                      </div>
                    );

                    if (typeof object.button !== "undefined") {
                      button = (
                        <div className="vt2 middle-addelem">
                          <Link
                            to={object.button.link}
                            className="vt2 more_button"
                          >
                            {" "}
                          </Link>
                        </div>
                      );
                    }

                    if (i == 0) {
                      return (
                        <div
                          className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
                          key={i}
                        >
                          <div className="vt2 row">
                            <Link to={object.button.link}>
                              <div
                                className="vt2 middle-postblock middle-postblock--box ChopinLists__middle-postblock--box"
                                // style={{
                                // 	backgroundImage: `url(${object.img})`,
                                // 	height: "150px"
                                // }}
                              >
                                {img}
                                {/* <p>

																{object.audio}
															</p> */}
                              </div>
                              <div>
                                <div
                                  className="ChopinLists__text-button"
                                  dangerouslySetInnerHTML={_this.createMarkup(
                                    object.text
                                  )}
                                />

                                {/* {button} */}
                                {object.audio && (
                                  <span className="audio__wrapper audio__wrapper--vt-13">
                                    <AudioPlayer
                                      src="https://dev.seraaq.com/nifc_nowa_strona/api_chopin/assets/audio.mp3"
                                      controls={true}
                                    />
                                  </span>
                                )}
                                <div
                                  className="ChopinLists__sub-title"
                                  dangerouslySetInnerHTML={_this.createMarkup(
                                    object.sub_title
                                  )}
                                />
                              </div>
                            </Link>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
                          key={i}
                        >
                          <div className="vt2 row">
                            <Link to={object.button.link}>
                              <div
                                className="vt2 middle-postblock middle-postblock--box ChopinLists__middle-postblock--box"
                                // style={{
                                // 	height: "150px",
                                // 	background: `url(${object.img})`
                                // }}
                              >
                                {img}
                              </div>
                              <div>
                                <div
                                  className="ChopinLists__text-button"
                                  dangerouslySetInnerHTML={_this.createMarkup(
                                    object.text
                                  )}
                                />

                                {/* {button} */}
                                {object.audio && (
                                  <span className="audio__wrapper audio__wrapper--vt-13">
                                    <AudioPlayer
                                      src="https://dev.seraaq.com/nifc_nowa_strona/api_chopin/assets/audio.mp3"
                                      controls={true}
                                    />
                                  </span>
                                )}
                                <div
                                  className="ChopinLists__sub-title"
                                  dangerouslySetInnerHTML={_this.createMarkup(
                                    object.sub_title
                                  )}
                                />
                              </div>
                            </Link>
                          </div>
                        </div>
                      );
                    }
                  }
                } else {
                  var color = "rgba(0,156,178,0.5)";

                  if (
                    object !== "undefined" &&
                    object.hasOwnProperty("img") &&
                    !object.hasOwnProperty("text")
                  ) {
                    var img = object.img;
                    var thumbnail = (
                      <div
                        style={{
                          flex: 1,
                          backgroundColor: color,
                          padding: 10,
                          color: "white",
                          position: "absolute",
                          left: 15,
                          right: 15,
                        }}
                      >
                        {object.title}
                      </div>
                    );
                    return (
                      <div
                        className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        key={i}
                      >
                        <div>
                          {thumbnail}
                          <img src={img} className="vt2 list_image" />
                        </div>
                      </div>
                    );
                  } else if (object !== "undefined") {
                    var button = null;
                    var img = object.img;
                    var thumbnail = (
                      <div
                        className="vt2 middle-thumbnailholder"
                        style={{
                          flex: 1,
                          backgroundColor: color,
                          padding: 10,
                          color: "white",
                        }}
                      >
                        {object.title}
                      </div>
                    );
                    var img = (
                      <div>
                        <img src={img} />
                      </div>
                    );

                    if (typeof object.button !== "undefined") {
                      button = (
                        <div className="vt2 middle-addelem">
                          <Link
                            to={object.button.link}
                            className="vt2 more_button"
                          >
                            {" "}
                          </Link>
                        </div>
                      );
                    }

                    if (i == 0) {
                      return (
                        <div
                          className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center "
                          key={i}
                        >
                          <div className="vt2 middle-postblock">
                            {img}
                            <div
                              dangerouslySetInnerHTML={_this.createMarkup(
                                object.text
                              )}
                            />
                            {button}
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
                          key={i}
                        >
                          <div className="vt2 middle-postblock">
                            {img}
                            <div
                              dangerouslySetInnerHTML={_this.createMarkup(
                                object.text
                              )}
                            />
                            {button}
                          </div>
                        </div>
                      );
                    }
                  }
                }
              })}
            </div>
            {paginationList}
          </div>
        </div>
        {/* <div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
					{calendar ? (
						<div className="vt2 RightMenu">
							<ul className="vt2 right_menu_items">
								{this.state.r_menu.map(function(object, i) {
									var var4 = object.url ? object.url : "";
									var var5 = object.name ? object.name : "";
									//console.log("RightMenu", object);
									return (
										<li className="vt2 left-menuItem" key={i}>
											<Link className="vt2 left-menuUnit" to={"/" + var4}>
												{var5}
											</Link>
										</li>
									);
								})}
							</ul>
						</div>
					) : (
						<div className="vt2 RightMenu">
							<div className="vt2 right_menu_items right_menu_items--search">
								<input className="vt2 search_input" type="text" />
								<p className="vt2 search_input__description">
									szukanie zaawansowane
								</p>
							</div>
						</div>
					)}
				</div> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_13/index.js